import React from 'react';
//import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { GetWorkingType, HEADERS, getOrgId } from '../../api';

function EditLeaveSetting() {
  //const { register, handleSubmit, errors } = useForm();


  const fetchWorkingTypes = async () => {
    const OrgID = getOrgId();

    try {
      const response = await axios.post(GetWorkingType, {
        org_id: OrgID,
      }, { headers: HEADERS });

      if (response.data.response_code === '0000') {
        const selectElement = Swal.getPopup().querySelector('#associated_working_day_type');
        selectElement.innerHTML = '';

        response.data.working_type.forEach((workingType) => {
          const option = document.createElement('option');
          option.value = workingType.working_id;
          option.text = workingType.working_name;
          selectElement.add(option);
        });
      } else {
        console.error('Failed to fetch working types from the API');
      }
    } catch (error) {
      console.error('Error fetching working types:', error);
    }
  };

  const generate_password = () => {
    // Define your password generation logic here
  };

  const onSubmit = () => {
    window.location.href = '/leave-page/leave-setting';
  };

  return (
    <div className="form-table">
      <div className="table-heading text-left p-1">
        <span className='breachCrumb'>
          <Link to="/leave-page/leave-setting">Leave Setting</Link> /{' '}
          <Link to="/AddLeaveSetting">Update Leave</Link>
        </span>
        <h5>Update Leave </h5>
      </div>

      <div className="input-form p-3">
        <div className="row d-flex">
          <div className="col-md-6 pr-3">
            <div className="form-group">
              <div className="input-group">
                <span>Leave Policy</span>
                <input
                  type="text"
                  placeholder="Enter leave enable"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Leave Enable</span>
                <input
                  type="text"
                  placeholder="Enter leave enable"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Leave Type</span>
                <input
                  type="text"
                  placeholder="Leave Type"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Effective Date</span>
                <input
                  type="date"
                  placeholder="Enter your first name"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Initial Set To Day</span>
                <input
                  type="number"
                  placeholder="number of days"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Earn Days</span>
                <input
                  type="number"
                  placeholder="Enter your email"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Earn Period</span>
                <input
                  type="text"
                  placeholder="Enter "

                />
                <span className="warning"></span>
              </div>
            </div>
          </div>


          <div className="col-md-6 pl-3">
            <div className="form-group">
              <div className="input-group">
                <span>Reset At</span>
                <input
                  type="text"
                  placeholder="Enter your first name"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Reset Days</span>
                <input
                  type="number"
                  placeholder="Enter "

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Restricted Day Off</span>
                <input
                  type="text"
                  placeholder="Enter leave enable"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Special Case</span>
                <input
                  type="text"
                  placeholder="Enter leave enable"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Approval Department</span>
                <input
                  type="text"
                  placeholder="Enter your first name"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Max Consicutive Days</span>
                <input
                  type="number"
                  placeholder="Enter your first name"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Description Required</span>
                <input
                  type="text"
                  placeholder="Enter leave enable"

                />
                <span className="warning"></span>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group">
                <span>Restricted Date</span>
                <input
                  type="date"
                  placeholder="Enter your first name"

                />
                <span className="warning"></span>
              </div>
            </div>
          </div>
        </div>
        <div className="button-next mt-3">
          <button type="submit" className="button-pre" onClick={onSubmit}>
            Update
          </button>
        </div>
      </div>
    </div>

  );
}

export default EditLeaveSetting;
